import styled from "styled-components";

import Link from "next/link";
import Image from "next/image";
const PaywallModal = ({ toggleModal }: { toggleModal: () => void }) => {
  //handler function for signin with Google

  return (
    <LoginContainer onClick={(e) => e.stopPropagation()}>
      <Image
        width={20}
        height={20}
        src="/assets/images/cancel.svg"
        onClick={() => {
          toggleModal();
        }}
        alt="cancel button"
      />
      <h1 className="text-gray-600">
        <span className="text-lg text-gray-600">InstantApply</span>
        Go Premium
      </h1>
      <p>Subscribe to Enjoy More Cover Letter generation</p>
      <div>
        <Link
          href="/pricing"
          target="_blank"
          className="p-5 py-3 rounded-md text-white bg-blue-500"
        >
          Pay Now
        </Link>
      </div>
    </LoginContainer>
  );
};

const LoginContainer = styled.div`
  background-color: #fff;
  border-radius: 10px;
  width: 80%;
  max-width: 650px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 0;
  box-shadow: 1px 1px 10px rgba(255, 255, 255, 0.4);
  position: relative;
  svg {
    max-width: 50px;
  }
  img {
    width: 3rem;
    transform-origin: 100% 0;
    opacity: 1;
    position: absolute;
    top: 1rem;
    right: 1.5rem;
    transform: scale(0.28);
  }
  h1 {
    font-weight: 700;
    font-size: 24px;
    text-align: center;

    span {
      display: block;
      margin-bottom: 0.5em;
    }
    @media (min-width: 768px) {
      font-size: 48px;
    }
  }

  p {
    font-weight: 400;
    font-size: 16px;
    color: #858282;
    margin: 0.5em 0 2em 0;
    text-align: center;
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }

  .google-logo {
    margin-right: 0.8em;
    font-weight: 700;
    height: 30px;
  }
`;

export default PaywallModal;
